import { render, staticRenderFns } from "./LotterySystemsPerformance.vue?vue&type=template&id=6dc21e8c&scoped=true&"
import script from "./LotterySystemsPerformance.vue?vue&type=script&lang=js&"
export * from "./LotterySystemsPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc21e8c",
  null
  
)

export default component.exports